import { Wizard } from "mailup-web-components";
import React, { type FC } from "react";
import { useIntl } from "react-intl";
import { useRecoilCallback, useRecoilValue } from "recoil";
import { WizardSteps } from "../model";
import { changeWizardStepCallback } from "../recoil/callbacks";
import { importFileWizardStepState } from "../recoil/state/state";
import { useParams } from "react-router-dom";

const WizardContainer: FC = () => {
  const intl = useIntl();
  const step = useRecoilValue(importFileWizardStepState);
  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, []);
  const { type } = useParams();

  const options = [
    ...(type === "file"
      ? [
          {
            label: intl.formatMessage({ id: "Load.FileImport.WizardStep1" }),
            value: WizardSteps.UploadFile,
            enabled:
              step === WizardSteps.Preview ||
              step === WizardSteps.UploadFile ||
              step === WizardSteps.DynimicFields ||
              step === WizardSteps.GroupsAndSettings,
          },
          {
            label: intl.formatMessage({ id: "Load.FileImport.WizardStep2" }),
            value: WizardSteps.Preview,
            enabled:
              step === WizardSteps.GroupsAndSettings ||
              step === WizardSteps.Preview ||
              step === WizardSteps.DynimicFields,
          },
          {
            label: intl.formatMessage({ id: "Load.FileImport.WizardStep3" }),
            value: WizardSteps.DynimicFields,
            enabled:
              step === WizardSteps.GroupsAndSettings ||
              step === WizardSteps.DynimicFields,
          },
        ]
      : []),
    ...(type === "copyandpaste"
      ? [
          {
            label: intl.formatMessage({
              id: "Load.FileImport.CopyPasteWizardStep1",
            }),
            value: WizardSteps.CopyPaste,
            enabled:
              step === WizardSteps.CopyPaste ||
              step === WizardSteps.GroupsAndSettings,
          },
        ]
      : []),
    {
      label: intl.formatMessage({ id: "Load.FileImport.WizardStep4" }),
      value: WizardSteps.GroupsAndSettings,
      enabled: step === WizardSteps.GroupsAndSettings,
    },
  ];

  return <Wizard value={step} options={options} onChange={changeWizardStep} />;
};

export default WizardContainer;
